const Footer = () => (
  <footer data-testid="footer-container" className="border-t border-border py-12">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="flex flex-col items-start justify-between gap-8 md:flex-row md:items-center">
        <div className="flex items-baseline gap-1.5">
          <span className="font-display text-xl font-bold tracking-tight text-primary">Plano</span>
          <span className="font-display text-xl font-bold italic tracking-tight text-accent">40+</span>
        </div>
        <nav className="flex flex-wrap gap-6 text-sm text-muted-foreground">
          <a
            data-testid="footer-terms-link"
            href="#"
            className="transition-colors duration-300 hover:text-foreground"
          >
            Termos de uso
          </a>
          <a
            data-testid="footer-privacy-link"
            href="#"
            className="transition-colors duration-300 hover:text-foreground"
          >
            Política de privacidade
          </a>
          <a
            href="mailto:suporte@plano40.com.br"
            className="transition-colors duration-300 hover:text-foreground"
          >
            suporte@plano40.com.br
          </a>
        </nav>
      </div>
      <p className="mt-8 max-w-3xl text-xs leading-relaxed text-muted-foreground/80">
        Este produto não substitui o acompanhamento de médicos, nutricionistas ou outros
        profissionais de saúde. Os resultados podem variar de pessoa para pessoa.
      </p>
      <p className="mt-4 text-xs text-muted-foreground/80">
        © 2026 Plano 40+. Todos os direitos reservados.
      </p>
    </div>
  </footer>
);

export default Footer;
